import { withStyles } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import clsx from 'clsx';
import React from 'react';

const StyledInputLabel = withStyles({
  root: {
    width: '40%',
  },
  formControl: {
    position: 'relative',
    transform: 'none',
  },
  shrink: {
    fontSize: '13px !important',
    transform: 'none',
  },
})(InputLabel);

const StyledFormHelperText = withStyles({
  root: {
    width: '60%',
    textAlign: 'right',
    margin: '0',
    fontFamily: 'Basier Circle',
    fontSize: '13px',
    fontWeight: '400',
    lineHeight: '18px',
    letterSpacing: '-0.2px',
    paddingLeft: '5px',
  },
  error: {
    '&&': {
      color: '#ED2726',
    },
  },
})(FormHelperText);

const StyledInput = withStyles({
  formControl: {
    'label + &': {
      marginTop: 0,
    },
  },
  input: {
    padding: '8px 0',
  },
})(Input);

const FormAuthTextField = props => {
  const {
    autoComplete,
    classes = {},
    className,
    disabled = false,
    FormHelperTextProps,
    fullWidth = false,
    id,
    input,
    InputLabelProps,
    label,
    name,
    meta: { touched, error },
    placeholder,
    submissionError,
    type,
    ...other
  } = props;

  const hasError = !!(submissionError || (touched && error));
  const helperText = submissionError || (touched && error);

  const inputLabelId = label && id ? `${id}-label` : undefined;
  const helperTextId = helperText && id ? `${id}-helper-text` : undefined;

  return (
    <FormControl
      className={clsx(classes.root, className)}
      disabled={disabled}
      error={hasError}
      fullWidth={fullWidth}
      {...other}
    >
      {label && (
        <StyledInputLabel
          htmlFor={id}
          shrink={true}
          id={inputLabelId}
          {...InputLabelProps}
        >
          {label}
        </StyledInputLabel>
      )}

      {helperText && (
        <StyledFormHelperText id={helperTextId} {...FormHelperTextProps}>
          {helperText}
        </StyledFormHelperText>
      )}

      <StyledInput
        aria-describedby={helperTextId}
        autoComplete={autoComplete}
        fullWidth={fullWidth}
        id={id}
        name={name}
        type={type}
        placeholder={placeholder}
        {...input}
      />
    </FormControl>
  );
};

export default FormAuthTextField;



// WEBPACK FOOTER //
// ./src/components/FormElements/FormAuthTextField.jsx